module.exports = __webpack_public_path__ + "static/media/Soybean10R3.5.c8504682.PNG";